module.exports = __webpack_public_path__ + "img/product_82.2f8589f.svg";